export default class MachineModel {
  media_id: number | null;
  media_url: string | null;
  media_blob: string | null;
  constructor() {
    this.media_id = null;
    this.media_url = null;
    this.media_blob = null;
  }
}
